import { render } from "./CommonInfo.vue?vue&type=template&id=4b91b8ac"
import script from "./CommonInfo.vue?vue&type=script&lang=js"
export * from "./CommonInfo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__